<template>
  <bbh-dialog
    ref="bbhDialog"
    :small="small"
    :big="big"
    :open-modal="localOpenModal"
    :custom-content-class="customContentClass"
    :show-close-button="showCloseButton"
    :overflow-hidden="overflowHidden"
    :scrollable="scrollable"
    dialog-color="var(--bbh-dark-blue)"
    @close="closeModal()"
    @click:outside="closeModal()"
    @click:esc="emitCancel()"
  >
    <template #icon>
      <v-icon
        v-if="icon"
        id="default-dialog-icon"
      >
        {{ icon }}
      </v-icon>
      <slot name="icon" />
    </template>
    <template 
      v-if="header" 
      #header
    >
      <span :class="{ centerHead: centerHeader }">{{ header }}</span>
      <bbh-switch
        v-if="showHeaderToggle"
        class="tw-inline-block tw-float-right tw-mr-8 tw-capitalize"
        :text="'Bild einfügen'"
        :value.sync="localToggleValue"
        @update="handleToggle()"
      />
    </template>
    <template #opener>
      <div />
    </template>
    <template #text>
      <slot name="content" />
    </template>
    <template #actions>
      <slot name="buttons" />

      <slot name="abbrechen-button">
        <bbh-button
          class="dialogButton"
          text="Abbrechen"
          outlined
          color="var(--bbh-accent-orange-red)"
          @click="emitCancel"
        />
      </slot>
    </template>
  </bbh-dialog>
</template>

<script>
export default {
  name: 'DefaultDialog',
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    customContentClass: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    overflowHidden: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    centerHeader: {
      type: Boolean,
      default: false,
    },
    showHeaderToggle: {
      type: Boolean,
      default: false,
    },
    headerToggleValue: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localOpenModal: false,
    localToggleValue: false,
  }),
  watch: {
    openModal(val) {
      this.localOpenModal = val;
    },
    headerToggleValue: {
      handler(val) {
        this.localToggleValue = val;
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.closeModal();
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    emitCancel() {
      this.$emit('cancel');
    },
    handleToggle() {
      this.$emit('update:value', this.localToggleValue);
    }
  },
};
</script>

<style lang="scss">
.centerHead {
  padding-left: 30px;
}
</style>
